import { render, staticRenderFns } from "./loader.vue?vue&type=template&id=18855a10&lang=pug"
import script from "./loader.vue?vue&type=script&lang=js"
export * from "./loader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports